import { render, staticRenderFns } from "./SejourDetail.vue?vue&type=template&id=e16804b6&"
import script from "./SejourDetail.vue?vue&type=script&lang=ts&"
export * from "./SejourDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports